import { usePutMutation } from "@/api/swr/useMutation";
import { z } from "zod";

type Config = Parameters<
  typeof usePutMutation<z.ZodUndefined, z.ZodUndefined>
>[3];

export const useSubmitAssessment = (config?: Config) => {
  return usePutMutation(
    z.undefined(),
    z.undefined(),
    `/app/assessment`,
    config,
  );
};
